import React from 'react'
import styled from 'styled-components'
import { Flex, Hide, theme } from 'pcln-design-system'
import { MediaCardCollection } from '@pcln/marketing'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import {
  isCollectionOfIMediaCard,
  isHomepageOrder
} from '@/shared-utils/content-model-type-guards'
import HeroCollectionWrapper from '@/components/HeroCollectionWrapper'
import MediaCardComponent from '../Promos/MediaCard/MediaCardComponent'

const StyledFlex = styled(Flex)`
  gap: 48px;
  ${theme.mediaQueries.md} {
    gap: 32px;
  }
`

type ContentfulOrderedItem = 'heroCollection' | 'topDeals'

function ContentfulItem({ name }: { name: ContentfulOrderedItem }) {
  const mediaCardsTopDealsData = useContentfulVariation(
    'mediaCardsTopDeals',
    isCollectionOfIMediaCard
  )

  if (name === 'heroCollection') {
    return <HeroCollectionWrapper />
  }
  return (
    <Hide md>
      {mediaCardsTopDealsData ? (
        <MediaCardCollection
          collection={mediaCardsTopDealsData}
          cardNode={MediaCardComponent}
        />
      ) : null}
    </Hide>
  )
}

export default function ContentfulOrderWrapper() {
  const { firstItem = 'heroCollection', secondItem = 'topDeals' } =
    useContentfulVariation('homepageOrder', isHomepageOrder) ?? {}
  return (
    <StyledFlex flexDirection="column">
      <ContentfulItem name={firstItem} />
      <ContentfulItem name={secondItem} />
    </StyledFlex>
  )
}
